import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map, tap } from 'rxjs/operators';
// import { ApplicationConstants } from '../constants/application-constants';
import { BehaviorSubject } from 'rxjs';

import { ApiAiClient } from 'api-ai-javascript';
import { ApiAiConstants } from 'api-ai-javascript/ts/ApiAiConstants';

import { Message } from '../model/chatbot.message.model';
import { Chatbot } from '../model/chatbot.model';
import { ChatbotVo } from '../model/chatbot.model.vo';
import { CHATBOT_NAME } from '../../shared/constants/chatbot-constants';
import { CHATBOT_WP_MODULE } from '../../shared/constants/chatbot-constants';
import { DataService } from '.././services/Data.service';
import { AuthService} from '.././services/auth.service';
import { ServerConstantsService, APP_STORAGE_USERNAME } from '../../shared';
import { lang } from 'moment';


@Injectable()
export class ChatbotService implements OnInit {
  private rscUrlChatbot: string;
  private chatbotDetails: ChatbotVo;
  ServerConstants: any;

  private apiAiclient: ApiAiClient;
  conversation = new BehaviorSubject<Message[]>([]);

  private errorMessage: string;
  private personName: string;

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private http: HttpClient,
    private serverConstantsService: ServerConstantsService
  ) {
      this.ServerConstants = serverConstantsService.getConstants();
      this.rscUrlChatbot =  this.ServerConstants.SERVER_API_URL + '/chatbot/details';

      /* Initialize the ChatbotDetails, and will try to instanciate ApiAiClient
       * This function was invoked here, due to the service doesn't have a template to load,
       * hence ngOnInit will never be called.
       */
      this.setChatbotDetails(CHATBOT_WP_MODULE);
  }

  ngOnInit(){ } // Never called

  converse(msg: string){
    // If ApiAiclient is not instantiated yet, then initialize it
    this.setChatbotDetails(CHATBOT_WP_MODULE);
    this.setPersonName();

    // Print User Message and send request to Server (AI Bot message)
    const userMessage = new Message(msg, this.personName, new Date());
    this.update(userMessage);
    try {
      // Getting response from AI Bot Server and printing message for Bot
      return this.apiAiclient.textRequest(msg)
        .then(response => {
          // const speech = response.result.fulfillment.speech; // commented to override botMessage when not match found
          let speech = response.result.fulfillment.speech;

          // Set default bot message when no match found in the flow
          if(!speech || speech.trim().length === 0){
            const NOT_MATCH: string = 'Sorry! I missed what you said. Can you say it again?';
            speech = NOT_MATCH;
          }

          const botMessage = new Message(speech, CHATBOT_NAME, new Date());
          this.update(botMessage);
        }//, include promise when error
        ).catch((error) => {
          console.log('error->dialog-flow->Unable to get a connection with AI Server!', error);
          this.errorMessage = 'Sorry! WR Assistance is unavailable at this moment.';
          this.update(new Message(this.errorMessage, CHATBOT_NAME, new Date()));
        });
    } catch(error){ //TODO: This chatbot should be removed, it will never be reached
      console.log('error->dialog-flow->catched error', error);
      this.errorMessage = 'Sorry! WR Assistance is unavailable at this moment.';
      this.update(new Message(this.errorMessage, CHATBOT_NAME, new Date()));
    }
  }

  /* Add message to source */
  update(msg: Message){
    this.conversation.next([msg]);
  }

  /* Set Person details */ // <-- needs to be updated to take person name rather than userName
  setPersonName(): string {
    if(!this.personName){
      return this.personName = window.localStorage.getItem(APP_STORAGE_USERNAME);
    }

    // Default value
    return 'user';
  }

  /**
   * Retrieve Chatbot details from WR DB
   * @param wrModule
   */
  getChatbotDetails(wrModule: string): Observable<ChatbotVo> {
    let chatbot: Chatbot = new Chatbot();
    chatbot.wrModule = wrModule;
    let chatbotVo: ChatbotVo = new ChatbotVo(chatbot);

    return this.http.post<ChatbotVo>(`${this.rscUrlChatbot}`, chatbotVo);
  }

  /**
   * Set Chatbot details, and initialize ApiAiClient before the first message is sent
   * @param wrModule
   */
  setChatbotDetails(wrModule: string){
    if(!this.chatbotDetails  && this.authService.isAuthenticated()){
      this.getChatbotDetails(wrModule).subscribe(
        data => this.chatbotDetails = data,
        error => {
          this.errorMessage = 'Sorry! WR Assistance is unavailable at this moment.';
          console.log('chatbot details->error', error)
        },
        () => console.log('complete')
      );
    }

    this.initApiAiClient();
  }

  /**
   * Initialize ApiAiclient with the details previously retrieved for ChatbotDetails
   */
  initApiAiClient(){
    if(this.chatbotDetails && this.chatbotDetails.chatbot && !this.apiAiclient){
      this.apiAiclient = new ApiAiClient({
        accessToken: this.chatbotDetails.chatbot.accessToken,
        baseUrl: this.chatbotDetails.chatbot.serverBaseUrl,
        version: this.chatbotDetails.chatbot.apiVersion
        // Include Language if needed. By default will take 'EN'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/chatbot.service.ts